//eslint-disable
import { Component, Vue, Watch } from 'vue-property-decorator';
import { DataSource, TableMessage, Type } from '../../interface';
import { EChartsOption, format } from 'echarts';

import { DataLoad } from '@/Utils/decorator/data-load';
import MessageBus from '@/Utils/message/message-bus';
import { NavigationInformationItem } from '@/component/NavigationInformation/menu-item/navigation-information';
import Tools from '@/component/template/tools/tools';
import api_data from '@/Api/api_data';
import { eventBus } from '@/main';

require('echarts/theme/macarons');

/**
 * @author guan
 * @description 基础加载数据父类
 */
@Component({
    components: {},
})
export default class FinanceLoad extends Vue {
    /** 有导航的情况下由子类复写 */
    Message: NavigationInformationItem[] = [];
    /** 加载状态 */
    spinningStatus = false;

    /** 当前数据类型,暂时添加type,特殊需求请自行添加 */
    dataType = {} as Type;
    /** 颜色列表 */
    readonly colorList = ['#46edcf', '#9a81ff', '#5983fb', '#ffa14a', '#3ad8db', '#fba38d', '#00bdf4', '#fc8819', '#2860fd', '#9556ff', '#2abbfe', '#ffc849'];

    /** 获取到的数据 */
    tableMessage = {} as TableMessage;
    /**
     * 表格数据
     */
    dataSource = [] as DataSource[];
    /**
     * 矩形树图数据
     */
    treeMapData = [] as DataSource[];

    /** 矩形树图 */
    treeMap = {};

    /** bar图 */
    barOption = {};

    /**
     * 表头字段数据
     */
    columns = [] as Array<Record<string, string>>;

    /**
     *
     */
    get cloudPssTheme(): string {
        return this.$store.getters.getTheme;
    }

    /**
     * @author guan
     * @description 获取路径信息
     * @return void
     */
    async LoadType(): Promise<void> {
        this.dataType = await this.$route.meta?.params;
    }
    /**
     *
     */
    getLevelOption(): object {
        return [
            {
                itemStyle: {
                    normal: {
                        borderColor: '#777',
                        borderWidth: 0,
                        gapWidth: 1,
                    },
                },
                upperLabel: {
                    normal: {
                        show: false,
                    },
                },
            },
            {
                itemStyle: {
                    normal: {
                        borderColor: '#555',
                        borderWidth: 5,
                        gapWidth: 1,
                    },
                    emphasis: {
                        borderColor: '#ddd',
                    },
                },
            },
            {
                colorSaturation: [0.35, 0.5],
                itemStyle: {
                    normal: {
                        borderWidth: 5,
                        gapWidth: 1,
                        borderColorSaturation: 0.6,
                    },
                },
            },
        ];
    }

    /**
     * 获得getTaskId
     */
    get taskId(): number {
        return this.$store.getters.getCurrentPlanId || 0;
    }

    /**
     *清除数据
     */
    cleanData(): void {
        this.dataSource = [] as DataSource[];
        this.treeMapData = [] as DataSource[];
        this.treeMap = {};
        this.barOption = {};
        this.columns = [] as Array<Record<string, string>>;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (this.$refs['charts'] as any).optionChange();
    }
    /**
     *获取当前planId
     */
    get currentPlanId(): number {
        return this.$store.getters.getCurrentPlanId;
    }
    /**
     *单次获取结果
     */
    @Watch('currentPlanId')
    @DataLoad()
    async loadData(): Promise<void> {
        /** 加载效果，自行使用 */
        try {
            const data = (await api_data.getTaskManagerData({ ...this.dataType, id: this.taskId })).results[0] as TableMessage;
            this.$nextTick(() => {
                this.tableMessage = data;
                if (data) {
                    this.handleDataColumn(this.tableMessage);
                    this.handleDataSource(this.tableMessage);
                } else {
                    this.cleanData();
                }
            });
        } catch (e) {
            this.tableMessage = {} as TableMessage;
            MessageBus.Notification('error', { description: '数据加载错误', message: '提示' });
            throw new Error(`未知错误,${e}`);
        }
    }

    /**
     * 处理原始数据
     * 生成表头
     */
    handleDataColumn(data: TableMessage): void {
        const targetColumn = [] as Array<Record<string, string>>;
        data.data.headerDesc.forEach((x) => {
            targetColumn.push({
                title: x.headerName,
                dataIndex: x.key,
                key: x.key,
            });
        });
        this.columns = targetColumn;
    }

    /**
     * 调用数据处理方法
     */
    handleDataSource(data: TableMessage): void {
        this.dataSource = this.genTreeData(data.data.data);
        this.treeMapData = this.genTreeMapData(this.dataSource);
        this.handleEchartsData(data, this.dataSource);
        this.treeMap = {
            tooltip: {
                formatter: (info: { value: string; treePathInfo: Array<Record<string, string>> }) => {
                    const value = info.value;
                    const treePathInfo = info.treePathInfo;
                    const treePath = [] as string[];

                    for (let i = 1; i < treePathInfo.length; i++) {
                        treePath.push(treePathInfo[i].name);
                    }

                    return ['<div class="tooltip-title">' + format.encodeHTML(treePath.join('/')) + '</div>', '费用: ' + format.addCommas(value) + '万元'].join(
                        '',
                    );
                },
            },
            series: [
                {
                    name: '利润与利润分配表',
                    type: 'treemap',
                    data: this.treeMapData,
                    visibleMin: 300,
                    label: {
                        show: true,
                        formatter: '{b}',
                    },
                    upperLabel: {
                        normal: {
                            show: true,
                            height: 30,
                        },
                    },
                    itemStyle: {
                        normal: {
                            borderColor: '#fff',
                        },
                    },
                    levels: this.getLevelOption(),
                },
            ],
        };
    }

    /**
     * 处理echarts数据
     */
    handleEchartsData(data: TableMessage, treeData: DataSource[]): void {
        const ParamKeys = [] as string[];
        for (const key in data.data.data[0]) {
            const val = Number(key);
            if (!isNaN(val)) {
                ParamKeys.push(key);
            }
        }
        this.barOption = this.genEchartsBarData(treeData, ParamKeys);
    }
    /**
     *
     */
    @Watch('cloudPssTheme')
    reload(): void {
        this.loadData().catch((e) => e);
    }
    /**
     * @param tabledata
     */
    genTreeData(tabledata: Array<Record<string, string>>): DataSource[] {
        //eslint-disable-next-line
        const tableTreeList: any[] = [];
        tabledata = tabledata.sort((a: Record<string, string | number>, b: Record<string, string | number>) => {
            //eslint-disable-next-line
            return ((a['serialNumber'] || a['序号']) as any).replace(/-/g, '') - ((b['serialNumber'] || b['序号']) as any).replace(/-/g, '');
        });
        for (const x of tabledata) {
            const serialNumber = (x['serialNumber'] || x['序号']).replace(/-/g, '.');
            const treePath = serialNumber.split('.');
            for (const ikea in x) {
                const val = Number(ikea);
                if (!isNaN(val)) {
                    x[ikea] = Number(Number(x[ikea]).toFixed(2)).toString();
                }
            }
            //eslint-disable-next-line
            const tp = this.getTreeParent(serialNumber, tableTreeList) as any;
            if (tp) {
                if (tp.children) {
                    tp.children.push({
                        ...x,
                    });
                } else {
                    tp.children = [{ ...x }];
                }
            } else {
                if (treePath.length === 1) {
                    tableTreeList.push({ ...x });
                }
            }
        }
        return tableTreeList;
    }

    /**
     * 获得tree parent
     *
     * @param key
     * @param datasource
     */
    getTreeParent(key: string, datasource: Array<Record<string, string>>): Array<Record<string, string>> | undefined {
        //eslint-disable-line
        const key_path = key.split('.');
        let temp_key = key_path[0];
        let temp_data = datasource;
        let flag = false;
        //eslint-disable-next-line
        for (const x in key_path) {
            //eslint-disable-next-line
            for (const y in temp_data) {
                const serialNumber = temp_data[y]['序号'] || temp_data[y]['serialNumber'];
                if (serialNumber === temp_key) {
                    if (parseInt(x) === key_path.length - 2) {
                        flag = true;
                        temp_data = temp_data[y] as unknown as Array<Record<string, string>>;
                        break;
                    } else {
                        temp_data = temp_data[y].children as unknown as Array<Record<string, string>>;
                        temp_key = temp_key + '.' + key_path[parseInt(x) + 1];
                        break;
                    }
                }
            }
        }
        if (flag) {
            return temp_data;
        }
        return;
    }

    /**
     * 解析为Bar图
     *
     * @param datasource
     * @param paramkeys
     */
    genEchartsBarData(datasource: DataSource[], paramkeys: string[]): EChartsOption {
        return {
            legend: {
                data: datasource.map((item: DataSource) => {
                    return item['项目'];
                }),
                textStyle: {
                    color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                },
            },
            xAxis: {
                type: 'category',
                axisTick: { show: false },
                data: paramkeys,
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                    },
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#4877fb',
                        width: '1',
                    },
                },
            },
            yAxis: {
                type: 'value',
                splitLine: {
                    show: false,
                },
                axisLabel: {
                    show: true,
                    textStyle: {
                        color: this.cloudPssTheme === 'dark' ? '#ffffff' : '#000',
                    },
                },
                axisLine: {
                    lineStyle: {
                        type: 'solid',
                        color: '#4877fb',
                        width: '1',
                    },
                },
            },
            dataZoom: [
                {
                    type: 'slider',
                    show: true,
                    xAxisIndex: [0],
                    start: 0,
                    end: 100,
                },
            ],
            series: datasource.map((item: DataSource) => {
                return {
                    name: item['项目'],
                    type: 'bar',
                    barGap: '0%',
                    data: paramkeys.map((item1: string) => {
                        return item[item1];
                    }),
                };
            }),
        } as unknown as EChartsOption;
    }

    /**
     * 递归
     * 解析为treeMap图
     *
     * @param dataSource
     * @param key
     * @param path
     */
    genTreeMapData(dataSource: DataSource[], key?: string, path?: string): DataSource[] {
        if (!key) {
            key = '合计/平均';
        }
        const retList = dataSource.map((item: DataSource) => {
            let countParma = 0;
            for (const ikey in item) {
                const val = Number(ikey);
                const value = item[ikey];
                if (!isNaN(val)) {
                    countParma += Number(value);
                }
            }
            if (item.children) {
                return {
                    name: item['项目'],
                    path: path ? path + '/' + item['项目'] : item['项目'],
                    value: Math.abs(countParma).toFixed(2),
                    children: this.genTreeMapData(item.children, key, path ? path + '/' + item['项目'] : item['项目']),
                };
            } else {
                return {
                    name: item['项目'],
                    value: Math.abs(countParma).toFixed(2),
                    path: path ? path + '/' + item['项目'] : item['项目'],
                };
            }
        });
        return retList;
    }

    /**
     * @author guan
     * @description 开局加载数据
     * @return void
     */
    mounted(): void {
        eventBus.$on(`reloadData`, () => {
            this.loadData().catch((e) => e);
        });
        this.LoadType.apply(this, [])
            .then(() => {
                this.loadData().catch((e) => e);
            })
            .catch((e) => e);
    }

    /**
     *
     */
    async exportToFile(): Promise<void> {
        const sheetData = new Array<Array<string | number>>();
        sheetData.push(this.columns.map((item) => item.title));
        const dataIndexList = this.columns.map((item) => item.dataIndex);
        this.dataSource.forEach((row) => {
            sheetData.push(dataIndexList.map((dataIndex) => row[dataIndex]));
            if (row.children != null && row.children.length > 0) {
                row.children.forEach((childRow) => {
                    sheetData.push(dataIndexList.map((dataIndex) => childRow[dataIndex]));
                });
            }
        });
        await Tools.exportXlsxFile(this.$route.meta?.title, [{ name: this.$route.meta?.name, data: sheetData }]);
    }

    /**
     * @author guan
     * @description 保存参数,请重写此方法
     * @return void
     */
    async saveData(): Promise<void> {
        // try {
        //     const data = await api_data.patchEvaluationDataByParams({ ...this.tableMessage, type: this.dataType.type }, {}).catch((e) => e);
        //     MessageBus.Notification('success', { description: '保存成功', message: '提示' });
        // } catch (e) {
        //     MessageBus.Notification('error', { description: '保存失败', message: '提示' });
        //     throw new Error(`保存失败，未知错误,${e}`);
        // }
    }
}
